import { Observable, of } from "rxjs";

export class StreamAudio {
  static captureVolume(stream: MediaStream): CaptureStreamAudioVolumeData {
    const audioTracks = stream.getAudioTracks();
    if (!audioTracks.length) {
      return { context: null, values$: of(0) };
    }

    const audioContext = new AudioContext();
    const analyser = audioContext.createAnalyser();
    const microphone = audioContext.createMediaStreamSource(stream);
    const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

    const values$ = new Observable<number>((subscriber) => {
      analyser.smoothingTimeConstant = 0.8;
      analyser.fftSize = 1024;

      microphone.connect(analyser);
      analyser.connect(scriptProcessor);
      scriptProcessor.connect(audioContext.destination);
      scriptProcessor.onaudioprocess = () => {
        const array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        const arraySum = array.reduce((a, value) => a + value, 0);
        const average = arraySum / array.length;

        subscriber.next(average);
      };

      // Cannot use TearDown logic
      // because of the async nature of the AudioContext
    });

    return {
      context: {
        audioContext,
        analyser,
        microphone,
        scriptProcessor
      },
      values$
    };
  }

  static async releaseVolume(capture: CaptureStreamAudioVolumeData) {
    const { context } = capture;
    if (!context) {
      return;
    }

    const { audioContext, analyser, microphone, scriptProcessor } = context;

    scriptProcessor.disconnect();
    microphone.disconnect();
    analyser.disconnect();
    return audioContext.close();
  }
}

export interface CaptureStreamAudioVolumeData {
  context: null | {
    audioContext: AudioContext;
    analyser: AnalyserNode;
    microphone: MediaStreamAudioSourceNode;
    scriptProcessor: ScriptProcessorNode;
  };
  values$: Observable<number>;
}
